import React, { useState } from "react";
import { auth, db } from "../firebase-config";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import "../styles/selectUserName.css"

const SelectUsername = () => {
  const [username, setUsername] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleUsernameSubmit = async (e) => {
    e.preventDefault();

    try {
      // Check if the username is already taken
      const usernameDocRef = doc(db, "usernames", username);
      const usernameDoc = await getDoc(usernameDocRef);

      if (usernameDoc.exists()) {
        setError("Username already taken. Please choose another.");
        return;
      }

      // Save the username
      const uid = auth.currentUser.uid;

      // Create an entry in "usernames" collection
      await setDoc(usernameDocRef, { uid });

      // Add username to the "users" document
      await setDoc(doc(db, "users", uid), { username }, { merge: true });

      navigate("/dashboard");
    } catch (err) {
      console.error("Error saving username:", err.message);
      setError("Something went wrong. Please try again.");
    }
  };

  return (
    <div className="select-username-container">
      <h2>Choose a Username</h2>
      <form onSubmit={handleUsernameSubmit}>
        <input
          type="text"
          placeholder="Enter a unique username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
        />
        <button type="submit">Save Username</button>
      </form>
      {error && <p className="error">{error}</p>}
    </div>
  );
};

export default SelectUsername;
